module.exports = __webpack_public_path__ + "assets/img/sabc_tick_bglist.webp?1554132091a57c7166acf312aa5888ad";